import React, { useState } from 'react'
import { LamePage } from './LamePage'
import { TourItem } from './components/TourItem';
import { TourHeader } from './components/TourHeader';
import { useMediaQuery } from '@mui/material';
import { CircularProgress } from '@mui/material';
import axios from 'axios';

export const Tour = () => {
  const [tour, setTour] = useState([])
  const [loading, setLoading] = useState(true)
  const matches = useMediaQuery('(max-width:400px)');

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${month}-${day}-${year}`;
  }

  const getTour = async () => {
    try {
      const res = await axios.get('https://rest.bandsintown.com/artists/lame%20genie/events?app_id=0632ef30b2a37c7839389bc7215e9f80')
      setTour(res.data);
      console.log(res.data)
    } catch (error) {
      console.error('Error fetching tour dates:', error)
    } finally {
      setLoading(false);
    }
  }

  const upcomingTourDates = tour.filter((item) => new Date(item.datetime) >= new Date())
  
  React.useEffect(() => {
    getTour();
    console.log(upcomingTourDates)
  }, [])

  return (
    <LamePage otherClass='tour'>
      { !loading ?
      <div>
        <h1>Tour</h1>
        { !matches && <TourHeader /> }
        { upcomingTourDates.length > 0 ?
        upcomingTourDates.map((item, index) => {
          return <TourItem 
            key={index} 
            date={formatDate(item.datetime)} 
            venue={item.venue.location} 
            info={item.title} 
            ticketLink={item.offers[0]?.url} 
            description={item.description}
            title={item.title}
            location={`${item.venue.city}, ${item.venue.region}`}
          />
        }) : <h1>No upcoming tour dates</h1>
        }
      </div>
      : 
      <div className='d-flex w-100 justify-content-center align-items-center' style={{height: '50vh'}}>
        <CircularProgress color="secondary" />
      </div>}
    </LamePage>
  )
}
